<template>
  <div class="pc-search">
    <el-form :model="keywordData" :inline="true">
      <el-form-item label="名称" class="title">
        <el-input v-model="keywordData.name_keywords[0]"></el-input>
      </el-form-item>
      <el-form-item label="词条分类" class="classification">
        <el-select
          v-model="keywordData.classification_id"
          clearable
          placeholder="词条分类"
          class="classification"
        >
          <el-option
            v-for="(item, index) in entryClassificationList"
            :key="index"
            :label="item.chinese_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" clearable placeholder="状态" class="status">
        <el-select v-model="keywordData.status" clearable placeholder="状态">
          <el-option label="有效" value="1"></el-option>
          <el-option label="无效" value="0"></el-option>
        </el-select>
      </el-form-item>
      <br />
      <el-form-item label="作者" class="title">
        <el-input v-model="keywordData.author_keywords[0]"></el-input>
      </el-form-item>
      <el-form-item label="编号" class="number">
        <el-input-number
          v-model.number="keywordData.entry_id"
          placeholder=""
        ></el-input-number>
      </el-form-item>
    </el-form>

    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>

<script>
import { entryClassificationSearch_Api } from "@/apis/entry.api";
export default {
  data() {
    return {
      keywordData: {
          entry_id:null,
        name_keywords:[""],
        author_keywords: [""],
        classification_id: null,
        status: null,
      },
      entryClassificationList: {},
    };
  },
  mounted() {
    this.searchEntryClassification();
  },
  methods: {
    searchEntryClassification() {
      entryClassificationSearch_Api().then((res) => {
        this.entryClassificationList = res.data;
      });
    },
    search() {
      console.log(this.keywordData);
      this.$emit("search", this.keywordData);
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-search {
  @include table-search;
  .college {
    width: 300px;
  }
  .title {
    width: 400px;
  }
  .is-wupen {
    width: 200px;
    margin-right: 110px;
  }
  .tag {
    width: 300px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .status {
    width: 200px;
  }
  .keyword {
    width: 400px;
    height: 40px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/entry/components/EntrySearch.vue